// extracted by mini-css-extract-plugin
export default {"templateContainer":"Template_templateContainer__V6cVN"};